import Axios from "axios";

declare module "axios" {
  interface AxiosRequestConfig {
    systemOneApiConfig?: SystemOneApiConfig;
  }
}

interface SystemOneApiConfig {
  toastOnError: boolean;
}

const endpoint = <F extends (...args: any[]) => any, U extends (...args: any[]) => string>(
  fn: F,
  absoluteUrl: U,
  requestSizeLimit = 3145728
) => {
  return Object.assign(fn, { absoluteUrl, requestSizeLimit });
}

const api = Axios.create({ withCredentials: true });

const createApiFunctions = (baseURL: string, acceptLanguageValue?: string) => {
  api.defaults.baseURL = baseURL;
  if (acceptLanguageValue != null) {
    api.defaults.headers.common["Accept-Language"] = acceptLanguageValue;
  }

  const apiFunctions = {
    AdminOne: {
      MigrateRecipients: endpoint(
        (systemOneApiConfig?: SystemOneApiConfig) => api.get<string>(`/api/v1/adminone/MigrateRecipients`, { systemOneApiConfig }),
        () => `${baseURL}/api/v1/adminone/MigrateRecipients`,
        3145728
      ),
      CreateShowToDateRecords: endpoint(
        (truncateExisting: boolean, systemOneApiConfig?: SystemOneApiConfig) => api.post<server.dto.ApiResponseWrapper<string>>(`/api/v1/adminone/createshowtodaterecords`, undefined, { params: { truncateExisting }, systemOneApiConfig }),
        (truncateExisting: boolean) => `${baseURL}/api/v1/adminone/createshowtodaterecords?truncateExisting=${truncateExisting}`,
        3145728
      ),
      RefreshExternalIdentities: endpoint(
        (modifiedLongerThanHours: number, systemOneApiConfig?: SystemOneApiConfig) => api.post<string>(`/api/v1/adminone/updateexternalidentities`, undefined, { params: { modifiedLongerThanHours }, systemOneApiConfig }),
        (modifiedLongerThanHours: number) => `${baseURL}/api/v1/adminone/updateexternalidentities?modifiedLongerThanHours=${modifiedLongerThanHours}`,
        3145728
      )
    },
    Companies: {
      CachePointOfInterestMarkers: endpoint(
        (companyId: number, markers: server.dto.AddressMarker[], systemOneApiConfig?: SystemOneApiConfig) => api.post<server.dto.ApiResponse>(`/api/v1/companies/${companyId}/markers`, markers, { systemOneApiConfig }),
        (companyId: number) => `${baseURL}/api/v1/companies/${companyId}/markers`,
        3145728
      ),
      GetPointOfInterestMarkers: endpoint(
        (companyId: number, systemOneApiConfig?: SystemOneApiConfig) => api.get<server.dto.AddressMarker[]>(`/api/v1/companies/${companyId}/markers`, { systemOneApiConfig }),
        (companyId: number) => `${baseURL}/api/v1/companies/${companyId}/markers`,
        3145728
      ),
      GetNearbyAirports: endpoint(
        (companyId: number, radius: number, systemOneApiConfig?: SystemOneApiConfig) => api.get<server.dto.Airport[]>(`/api/v1/companies/${companyId}/nearbyAirports`, { params: { radius }, systemOneApiConfig }),
        (companyId: number, radius: number) => `${baseURL}/api/v1/companies/${companyId}/nearbyAirports?radius=${radius}`,
        3145728
      )
    },
    Register: {
      DeleteByPns: endpoint(
        (pns: any, systemOneApiConfig?: SystemOneApiConfig) => api.delete(`/api/v1/register/pns`, { systemOneApiConfig }),
        () => `${baseURL}/api/v1/register/pns`,
        3145728
      )
    }
  }

  return apiFunctions;
}

export { createApiFunctions, api };
